import { render, staticRenderFns } from "./AssistantsTable.vue?vue&type=template&id=6d98c132&scoped=true&"
import script from "./AssistantsTable.vue?vue&type=script&lang=ts&"
export * from "./AssistantsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98c132",
  null
  
)

export default component.exports